import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement } from '../Flex/index.js';

export type ListElement = FlexElement;

export const List = styled(Flex)
  .attrs({
    column: true,
  })
  .withConfig({
    displayName: 'List',
  })``;
